<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid user-manager">
      <div class="row">
        <div class="col-md-3 mt-5 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-3 margin-high col-sm-12">
            <h4>User Manager</h4>
            <h2>{{ getLockedString }} User</h2>
            <p>Username: {{ username }}</p>
            <p>Name: {{ fullName }}</p>
            <p>Why is this user being {{getLockedString}}ed ?</p>
            <b-form-textarea v-model="reason" />
             <b-button-group>
            <b-button class="m-2" @click="submitLockChange">Confirm</b-button>
            <b-button class="m-2" @click="$router.push({
                name: 'AdminUserManager',
                params: {
                  activeMenuItem: 'usersUserManager',
                  activeMenu: 'users',
                },
              })">Return to User Manager</b-button>
             </b-button-group>
            <p v-if="!isSuccess && error && error.length > 0" class="text-danger">Error When submitting request: {{error}} </p>
            <p v-else-if="isSuccess" class="text-success"> User has been {{getLockedString}}ed!</p>
          </div>
        </transition>
      </div>
    </div>
    <appFooter></appFooter>
  </div>
</template>


<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AdminSidebar from "@/views/admin/AdminSidebar.vue";
import {updateUserLockById} from "@/api/user-manager"
export default {
  name: "LockEditConfirm",
  props: {
    userId: Number,
    newLockedState: Boolean,
    username: String,
    fullName: String,
  },
  data() {
    return {
      reason: "",
      error: "",
      isSuccess: false
    };
  },
  components: {
    appHeader: Header,
    appFooter: Footer,
    appAdminSidebar: AdminSidebar,
  },
  computed: {
    getLockedString() {
      console.log(this.newLockedState);
      return this.newLockedState ? "Lock" : "Unlock";
    },
  },
  methods: {
     async submitLockChange() {
      const resp = await updateUserLockById({userId: this.userId, isLocked: this.newLockedState,  comment: this.reason})

      console.log(resp)

      if (resp.status != 200) {
        this.error = resp.data.message ? resp.data.message : "unknown error"
        return
      }

      this.isSuccess = true
    }
  }
};
</script>

<style lang="scss">
.user-manager {
  margin: -14px 0 0 0;
}
.margin-high {
  margin-top: ($spacer * 5) !important;
}
</style>